import { FaLeaf } from "react-icons/fa";
import FoodDetailThemeBase from "./FoodDetailThemeBase";

const ORANGE = "#F5793B";
const DARK = "#1F2937";

const theme = {
  pageStyle: { backgroundColor: "#F9FAFB" },
  headerClassName: "sticky top-0 z-20 border-b border-gray-100 bg-white/95 backdrop-blur",
  headerInnerClassName: "mx-auto flex h-16 max-w-2xl items-center justify-between px-4",
  iconButtonClassName: "flex h-11 w-11 items-center justify-center rounded-xl text-xl hover:bg-gray-100",
  titleClassName: "font-black",
  titleStyle: { color: DARK },
  badgeClassName: "absolute -left-1 -top-1 rounded-full px-1.5 text-[10px] font-bold text-white",
  badgeStyle: { backgroundColor: ORANGE },
  cardClassName: "overflow-hidden rounded-2xl bg-white shadow-[0_1px_10px_rgba(0,0,0,0.06)]",
  PlaceholderIcon: FaLeaf,
  placeholderClassName: "flex aspect-[4/3] items-center justify-center text-6xl text-orange-200 sm:aspect-[16/9]",
  placeholderStyle: { backgroundColor: "#FFF3EA" },
  itemTitleClassName: "text-2xl font-black",
  itemTitleStyle: { color: DARK },
  descriptionClassName: "mt-3 leading-7 text-gray-500",
  priceStyle: { color: ORANGE },
  stepperClassName: "flex items-center rounded-full bg-white shadow",
  ctaClassName: "min-h-12 flex-1 rounded-full px-5 font-bold text-white shadow-lg",
  ctaStyle: { backgroundColor: ORANGE },
};

const NovaFoodDetailTheme = (props) => <FoodDetailThemeBase {...props} theme={theme} />;

export default NovaFoodDetailTheme;
